<template>
  <v-row align="center" class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-card-text>
        <v-row align="center" class="ma-0 pa-0">
          <v-col cols="2" class="pa-0">
            <v-toolbar flat height="21" color="transparent" >
              <v-spacer></v-spacer>
              <v-btn dark small icon @click.stop.prevent="toggle(item, 0)">
                <v-icon v-if="checkToggle(item, 0)" :color="pColor(item)">mdi-menu-up</v-icon>
                <v-icon v-else :color="pColor(item)">mdi-menu-down</v-icon>
              </v-btn>
            </v-toolbar>
          </v-col>
          <v-col cols="10" class="pa-0">
            <v-row align="center" class="ma-0 pa-0">
              <v-col class="pa-0" v-for="i in 13" :key="i">
                <v-sheet
                  :color="year == getFY() && mm == i ? pColor(item) : getWeekColor(1)"
                  dark
                  height="21"
                  :key="i"
                  tile
                  :class="i == 13 ? 'b-L-GREY b-R-GREY b-T-GREY text-center' : 'b-L-GREY b-T-GREY text-center'"
                >
                  <span :class="year == getFY() && mm == i ? 'white--text select-none' : 'secondary--text select-none'">{{ getMonth(i) }}</span>
                </v-sheet>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <template v-for="(metric, index) in headers">
          <v-row v-if="checkHide(item, metric.type) && metric.roles[getPrivilege(data)]" align="center" class="ma-0 pa-0" :key="index">
            <v-col cols="2" class="pa-0">
              <v-sheet color="transparent" tile :class="(headers.length - 1) == index && compare === 'N/A' ? 'b-L-GREY b-T-GREY b-B-GREY' : 'b-L-GREY b-T-GREY'" height="21">
                <template v-if="metric.type != 'header'">
                  <span class="pl-4 select-none">{{ metric.name + '（' + metric.sufix + '）' }}</span>
                </template>
                <template v-else>
                  <v-toolbar flat :color="pColor(item)" height="20">
                    <span class="white--text">{{ metric.name }}</span>
                    <v-spacer></v-spacer>
                      <template v-if="checkExpand(item, metric.key)">
                        <v-btn dark small icon @click.stop.prevent="toggle(item, metric.key)">
                          <v-icon v-if="checkToggle(item, metric.key)">mdi-menu-up</v-icon>
                          <v-icon v-else>mdi-menu-down</v-icon>
                        </v-btn>
                      </template>
                  </v-toolbar>
                </template>
              </v-sheet>
              <template v-if="compare != 'N/A'">
                <v-sheet :color="metric.type == 'header' ? pColor(item) : 'transparent'" tile :class="(headers.length - 1) == index ? 'b-L-GREY b-B-GREY' : 'b-L-GREY'" height="21">
                </v-sheet>
              </template>
            </v-col>
            <v-col cols="10" class="pa-0">
              <v-row align="center" class="ma-0 pa-0">
                <v-col class="pa-0" v-for="i in 13" :key="i">
                  <v-sheet
                    :class="getBackgroundColor(mm, i, index)"
                    :color="checkValue(item, i, index, metric)"
                    height="21"
                    :key="i"
                    tile
                  >
                    <template v-if="i != 13">
                      <span
                        style="text-align: right !important; width: 100%;"
                        :class="getAttr(item, i, index, metric)"
                        @click.stop="onValueSelect(item, i, 0, metric)"
                      >
                        {{ getValue(item, i, index, 0, metric) }}
                      </span>
                    </template>
                    <template v-else>
                      <span
                        style="text-align: right; width: 100%;"
                        class="pr-1 font-weight-bold"
                      >
                        {{ getTotalValue(item, index, metric, 0) }}
                      </span>
                    </template>
                  </v-sheet>
                </v-col>
              </v-row>
              <v-row v-if="compare != 'N/A'" align="center" class="ma-0 pa-0">
                <v-col class="pa-0" v-for="i in 13" :key="i">
                  <v-sheet
                    :class="i == 13 ? 'b-L-GREY b-R-GREY text-right' : 'b-L-GREY text-right'"
                    :color="compare == '目標' ? sColor : '#bbbbbb30'"
                    height="21"
                    :key="i"
                    tile
                  >
                    <span
                      v-if="i != 13"
                      style="text-align: right; width: 100%;"
                      class="pr-1"
                    >
                      {{ getValue(item, i, index, 1, metric) }}
                    </span>
                    <span v-else
                      style="text-align: right; width: 100%;"
                      class="pr-1 font-weight-bold"
                    >
                      {{ getTotalValue(item, index, metric, 1) }}
                    </span>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
export default {
  computed: {
    ...mapGetters({
      data: 'auth/data'
    })
  },
  props: [ 'groups', 'item', 'year', 'compare', 'indicator', 'headers', 'expand', 'items', 'plans', 'diffs', 'diffsRevises', 'revices', 'sColor' ],
  data () {
    return {
      mm: 0,
      exp: []
    }
  },
  watch: {
    groups () {
      this.createExpansions()
    }
  },
  created () {
    moment.tz.setDefault('Asia/Tokyo')
    var mm = moment().month()
    this.mm = mm > 2 ? mm - 2 : mm + 10
    this.createExpansions()
  },
  methods: {
    createExpansions () {
      this.exp = []
      if (!this.data || typeof this.data.groups === 'undefined') {
        return
      }
      if (this.getPrivilegesLevel(this.data) === 0) {
        Vue.set(this.exp, '*', JSON.parse(JSON.stringify(this.expand)))
        for (var index in this.groups) {
          if (this.groups[index].classroom) {
            Vue.set(this.exp, this.groups[index].key, JSON.parse(JSON.stringify(this.expand)))
          }
        }
      } else if (this.getPrivilegesLevel(this.data) < 3) {
        Vue.set(this.exp, '*', JSON.parse(JSON.stringify(this.expand)))
        var keys = Object.keys(this.data.schools)
        for (index in this.groups) {
          for (var x in keys) {
            if (this.data.schools[keys[x]]) {
              if (this.groups[index].classroom) {
                if (this.groups[index].schools[keys[x]]) {
                  Vue.set(this.exp, this.groups[index].key, JSON.parse(JSON.stringify(this.expand)))
                }
              }
            }
          }
        }
      } else {
        keys = Object.keys(this.data.groups)
        for (index in this.groups) {
          for (x in keys) {
            if (this.data.groups[keys[x]]) {
              if (this.groups[index].classroom) {
                if (this.groups[index].key === keys[x]) {
                  Vue.set(this.exp, this.groups[index].key, JSON.parse(JSON.stringify(this.expand)))
                }
              }
            }
          }
        }
      }
    },
    toggle (item, key) {
      var index = this.exp[item].findIndex(expand => expand.key === key)
      if (index !== -1) {
        this.exp[item][index].value = !this.exp[item][index].value
        if (key === 0) {
          for (var i in this.exp[item]) {
            this.exp[item][i].value = this.exp[item][index].value
          }
        }
      }
    },
    checkExpand (item, key) {
      if (typeof this.exp[item] === 'undefined') {
        return false
      }
      var index = this.exp[item].findIndex(expand => expand.key === key)
      if (index !== -1) {
        return this.exp[item][index].enable
      }
      return false
    },
    checkHide (item, type) {
      if (typeof this.exp[item] === 'undefined') {
        return false
      }
      var index = this.exp[item].findIndex(expand => expand.type === type)
      if (index !== -1) {
        return !this.exp[item][index].value
      }
      return true
    },
    checkToggle (item, key) {
      if (typeof this.exp[item] === 'undefined') {
        return false
      }
      var index = this.exp[item].findIndex(expand => expand.key === key)
      if (index !== -1) {
        return this.exp[item][index].value
      }
      return false
    },
    checkValue (item, i, index, metric) {
      if (metric.type === 'header' || metric.type === 'none') {
        return (this.year === this.getFY() && this.mm === i) ? this.pColor(item) : this.getWeekColor(1)
      }
      if (item === '*') {
        return 'transparent'
      }
      return 'transparent'
    },
    pColor (group) {
      var color = 'primary'
      if (group !== '*') {
        var index = this.groups.findIndex(g => g.key === group)
        if (index !== -1) {
          if (typeof this.groups[index].color !== 'undefined') {
            color = this.groups[index].color
          }
        }
      }
      return color
    },
    getBackgroundColor (mm, i, index) {
      var color = (i === 13 ? 'd-flex b-L-GREY b-R-GREY b-T-GREY' : 'd-flex b-L-GREY b-T-GREY')
      if ((this.headers.length - 1) === index && this.compare === 'N/A') {
        color += ' b-B-GREY'
      }
      return color
    },
    getAttr (item, month, index, metric) {
      var value = 'pr-1'
      if (metric.type === 'header' && this.year === this.getFY() && this.mm === month) {
        value += ' white--text'
      }
      if (this.revices[item] && this.revices[item][month - 1].enable) {
        value += ' select-none warning--text'
      } else {
        value += ' clickable select-none'
      }
      return value
    },
    getValue (item, month, index, type, metric) {
      var value = 0
      var diff = 0
      var plan = 0
      if (this.compare !== 'N/A' && this.indicator === '%') {
        if (this.compare === '目標') {
          if (this.items[item] && type === 0) {
            value = 0
            if (this.revices[item] && this.revices[item][month - 1].enable) {
              if (typeof this.revices[item][month - 1][metric.key] !== 'undefined') {
                value = this.revices[item][month - 1][metric.key].value
              }
            } else {
              value = this.items[item][month - 1][metric.key].length
            }
            plan = 0
            if (typeof this.plans[item][month - 1][metric.key] !== 'undefined') {
              plan = this.plans[item][month - 1][metric.key].value
            }
            var p = Math.floor(value / plan * 10) / 10
            value = isNaN(p) || p === Infinity ? '0%' : Math.round(p * 100) + '%'
          } else if (this.plans[item] && type === 1) {
            value = 0
            if (typeof this.plans[item][month - 1][metric.key] !== 'undefined') {
              value = this.plans[item][month - 1][metric.key].value
            }
          }
        } else {
          if (this.items[item] && type === 0) {
            value = 0
            if (this.revices[item] && this.revices[item][month - 1].enable) {
              if (typeof this.revices[item][month - 1][metric.key] !== 'undefined') {
                value = this.revices[item][month - 1][metric.key].value
              }
            } else {
              value = this.items[item][month - 1][metric.key].length
            }
            if (this.diffsRevises[item] && this.diffsRevises[item][month - 1].enable) {
              diff = this.diffsRevises[item][month - 1][metric.key].value
            } else {
              diff = this.diffs[item][month - 1][metric.key].length
            }
            p = Math.floor(value / diff * 10) / 10
            value = isNaN(p) || p === Infinity ? '0%' : Math.round(p * 100) + '%'
          } else if (this.diffs[item] && type === 1) {
            if (this.diffsRevises[item] && this.diffsRevises[item][month - 1].enable) {
              value = this.diffsRevises[item][month - 1][metric.key].value
            } else {
              value = this.diffs[item][month - 1][metric.key].length
            }
          }
        }
      } else {
        if (type === 0) {
          if (this.items[item]) {
            if (this.revices[item] && this.revices[item][month - 1].enable) {
              value = 0
              if (typeof this.revices[item][month - 1][metric.key] !== 'undefined') {
                value = this.revices[item][month - 1][metric.key].value
              }
            } else {
              value = this.items[item][month - 1][metric.key].length
            }
          }
        } else if (type === 1) {
          if (this.compare === '目標') {
            if (this.plans[item]) {
              value = 0
              if (typeof this.plans[item][month - 1][metric.key] !== 'undefined') {
                value = this.plans[item][month - 1][metric.key].value
              }
            }
          } else {
            if (this.diffs[item]) {
              if (this.diffsRevises[item] && this.diffsRevises[item][month - 1].enable) {
                value = this.diffsRevises[item][month - 1][metric.key].value
              } else {
                value = this.diffs[item][month - 1][metric.key].length
              }
            }
          }
        }
      }
      return value
    },
    getTotalValue (item, index, metric, type) {
      var a = 0
      var ac = 0
      var p = 0
      var pc = 0
      var d = 0
      var dc = 0
      if (!this.items[item]) {
        return 0
      }
      for (var x = 0; x < 12; x++) {
        var v = this.items[item][x][metric.key].length
        if (this.revices[item] && this.revices[item][x].enable) {
          v = 0
          if (typeof this.revices[item][x][metric.key] !== 'undefined') {
            v = this.revices[item][x][metric.key].value
          }
        }
        a += v
        if (v !== 0) {
          ac += 1
        }
      }
      if (this.compare === '目標') {
        for (x = 0; x < 12; x++) {
          v = 0
          if (typeof this.plans[item][x][metric.key] !== 'undefined') {
            v = this.plans[item][x][metric.key].value
          }
          p += v
          if (v !== 0) {
            pc += 1
          }
        }
      }
      if (this.compare !== 'N/A' && this.compare !== '目標') {
        for (x = 0; x < 12; x++) {
          v = this.diffs[item][x][metric.key].length
          d += v
          if (v !== 0) {
            dc += 1
          }
        }
      }
      if (type === 0) {
        if (this.compare !== 'N/A' && this.indicator === '%') {
          if (this.compare === '目標') {
            var r = Math.floor((a / ac) / (p / pc) * 100)
            return isNaN(r) || r === Infinity ? '0%' : r + '%'
          } else {
            r = Math.floor((a / ac) / (d / dc) * 100)
            return isNaN(r) || r === Infinity ? '0%' : r + '%'
          }
        } else {
          r = Math.floor(a / ac)
          return isNaN(r) || r === Infinity ? 0 : r
        }
      } else {
        if (this.compare === '目標') {
          r = Math.floor((p / pc))
          return isNaN(r) || r === Infinity ? 0 : r
        } else {
          r = Math.floor((d / dc))
          return isNaN(r) || r === Infinity ? 0 : r
        }
      }
    },
    onChange (event, item, i, index) {
      this.$emit('onChange', { event: event, item: item, i: i, index: index })
    },
    onValueSelect (item, month, type, metric) {
      this.$emit('onValueSelect', { item: item, month: month, type: type, metric: metric })
    }
  }
}
</script>

<style scoped>
span.clickable {
  cursor: pointer !important;
}
.select-none {
  user-select: none;
}
.b-R {
  border-right: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-L {
  border-left: 1px solid white !important;
  border-left-width: 1px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-T {
  border-top: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B {
  border-bottom: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-R-GREY {
  border-right: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-L-GREY {
  border-left: 1px solid #80808080 !important;
  border-left-width: 1px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-T-GREY {
  border-top: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B-GREY {
  border-bottom: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
